import PaidHome from "./PaidHome"
export default PaidHome
